<template>
  <div class="diy-card-catalogue__card-add">
    <SubmitButtonSlot
      :disabled="!hasEnoughSlots || loading || addingCard"
      :loading="loading"
      :show-message="!hasEnoughSlots"
      :tooltip-message="$t('ui.tooltips.insufficient_slots')"
      @click.native="hasEnoughSlots && addCard()"
    >
      <AppIcon icon="far fa-plus-circle" />
      {{ $t('ui.buttons.add') }}
    </SubmitButtonSlot>
  </div>
</template>

<script>
// Utilities
import { mapState } from 'vuex'
import { EventBus } from '@/main'
import { checkApiResponse } from 'Utils'
import RouterModalControl from 'Mixins/RouterModalControl'
// Components
import AppIcon from 'Ui/AppIcon'
import SubmitButtonSlot from 'Components/SubmitButtonSlot'

export default {
  name: 'CardCatalogueCardAdd',

  components: {
    AppIcon,
    SubmitButtonSlot,
  },

  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  mixins: [RouterModalControl],

  methods: {
    toggleLoadingStatus() {
      this.loading = !this.loading
    },

    async addCard() {
      if (this.loading) return
      this.toggleLoadingStatus()
      const accountInfo = {
        accountId: this.account.id,
        cardId: this.card.card_id,
      }
      const newCard = await this.$store.dispatch('client/addCard', accountInfo)

      if (!checkApiResponse(newCard)) return this.toggleLoadingStatus()
      this.closeModal()
      EventBus.$emit('reload-user-content')
    },
  },

  computed: {
    ...mapState({
      account: (state) => state.client.account,
      freeSlots: (state) => state.client.freeSlots,
      addingCard: (state) => state.client.addingCard,
    }),

    hasEnoughSlots() {
      if (this.$route.name === 'hire-card-modal') {
        return true
      } else {
        // Comparing free slots and card slots for availability
        return this.freeSlots - this.card.slots >= 0
      }
    },
  },
}
</script>

<style scoped>
.diy-card-catalogue__card-add {
  display: block;
  width: 100%;
}

@media (max-width: 680px) {
  .diy-card-catalogue__card-add >>> .submit-button {
    width: 100%;
  }
}
</style>
